import { createStore } from 'vuex'
// import router from '@/router'

// const route = router.options.history.location
// const name = route.substr(1, route.length)
// let defaultPageDate = ''

// try {
//   if (name.indexOf(localStorage.newspaper) === -1) {
//     defaultPageDate = ''
//   } else if (localStorage.pageDate) {
//     defaultPageDate = localStorage.pageDate
//     debugger
//   }
// } catch (e) {}
export default createStore({
  state: {
    name: '',
    newspaperId: '',
    newspaper: '',
    directoryId: '',
    pageDate: '',
    periodical: '',
    contentTitle: '',
    inputValue: '',
    swiperIndex: 0,
    contentIndex: 0,
    activeIndex: 0,
    pageList: {},
    allPageList: {},
    directoryList: {},
    defaultList: [],
    contentList: [],
    newsList: [],
    isStop: true
  },
  mutations: {
    getNewspaperId (state, str) {
      state.newspaperId = str
    },
    getNewspaper (state, str) {
      state.newspaper = str
      // try {
      //   localStorage.newspaper = str
      // } catch (e) {}
    },
    getPeriodical (state, str) {
      state.periodical = str
    },
    getSwiperIndex (state, str) {
      state.swiperIndex = str
    },
    addPageListData (state, str) {
      state.pageList = str
    },
    addAllPageListData (state, str) {
      state.allPageList = str
    },
    searchInputValue (state, str) {
      state.inputValue = str
    },
    getPageDate (state, str) {
      state.pageDate = str
      // try {
      //   localStorage.pageDate = str
      //   debugger
      // } catch (e) {}
    },
    getDirectoryList (state, str) {
      state.directoryList = str
      // debugger
    },
    getDefaultList (state, str) {
      state.defaultList = str
    },
    getContentIndex (state, str) {
      state.contentIndex = str
    },
    getContentTitle (state, str) {
      state.contentTitle = str
    },
    getContentList (state, str) {
      state.contentList = str
    },
    getDirectoryId (state, str) {
      state.directoryId = str
    },
    getActiveIndex (state, str) {
      state.activeIndex = str
    },
    getNewsList (state, str) {
      state.newsList = str
    },
    getVoiceState (state, str) {
      state.isStop = str
    }
  },
  actions: {
    getNewspaperId (store, str) {
      store.commit('getNewspaperId', str)
    },
    getNewspaper (store, str) {
      store.commit('getNewspaper', str)
    },
    getPeriodical (store, str) {
      store.commit('getPeriodical', str)
    },
    getSwiperIndex (store, str) {
      store.commit('getSwiperIndex', str)
    },
    addPageListData (store, str) {
      store.commit('addPageListData', str)
    },
    addAllPageListData (store, str) {
      store.commit('addAllPageListData', str)
    },
    searchInputValue (store, str) {
      store.commit('searchInputValue', str)
    },
    getPageDate (store, str) {
      store.commit('getPageDate', str)
    },
    getDirectoryList (store, str) {
      store.commit('getDirectoryList', str)
    },
    getDefaultList (store, str) {
      store.commit('getDefaultList', str)
    },
    getContentIndex (store, str) {
      store.commit('getContentIndex', str)
    },
    getContentList (store, str) {
      store.commit('getContentList', str)
    },
    getDirectoryId (store, str) {
      store.commit('getDirectoryId', str)
    },
    getContentTitle (store, str) {
      store.commit('getContentTitle', str)
    },
    getActiveIndex (store, str) {
      store.commit('getActiveIndex', str)
    },
    getNewsList (store, str) {
      store.commit('getNewsList', str)
    },
    getVoiceState (store, str) {
      store.commit('getVoiceState', str)
    }
  },
  modules: {
  }
})
